import { useContext, useEffect } from 'react';
import { MobXProviderContext, useObserver } from 'mobx-react';
import { CoachSkillCertificationState } from '../../mainv3/states/CoachSkillCertificationState';
import { GlobalStatesV3 } from '../states/GlobalStatesV3';
import { V3Routes } from '../../mainv3/routes';

/**
 * ページへのアクセスをスタッフのみに制限する際に使うHooks
 * 権限のないユーザがアクセスした場合には、トップにリダイレクトされる
 * TODO: Adminかのフラグをフロント側にも送信するかどうか検討中
 * @param allowedSkillNames 指定した場合は、指定されたスキル名のうちいずれかを持つスタッフのみを許可する。指定しない場合はいずれかのスキルが付与されている場合に許可
 */
export const restrictAccessForStaff = (allowedSkillNames = null) => {
    const context = useContext(MobXProviderContext);
    const skillState: CoachSkillCertificationState = context.coachSkillState;
    const { loading, hasAnySkill, hasAnySkills } = useObserver(() => ({
        loading: !skillState.initialized,
        hasAnySkills: skillState.hasAnySkills,
        hasAnySkill: skillState.hasAnySkill,
    }));
    useEffect(
        () => {
            if (loading) {
                return;
            }
            if (allowedSkillNames) {
                if (!hasAnySkills(allowedSkillNames)) {
                    GlobalStatesV3.routing.push(V3Routes.home());
                }
            } else {
                if (!hasAnySkill) {
                    GlobalStatesV3.routing.push(V3Routes.home());
                }
            }
        },
        [loading, allowedSkillNames]
    );
};
